import React from 'react'
import '../styles/header.css'
import { Link } from 'react-router-dom';
import TemporaryDrawer from './Drawer'
import Navlist from './Navlist';
export default function Header() {
  return (
    <>
      <div className="navbar">
        <div className="heading-cont">
          <h1 className=""><Link to="/" end = "true">Portfolio</Link></h1>
        </div>
          {/* Menu Button */}
          <TemporaryDrawer/>
          <Navlist/>
      </div>
    </>
  )
}
